<template></template>

<script>
import { EventBus } from "Public/store/modules/eventbus";
import { GLOBAL_EVENT_PERMISSION_DENIED } from "Consts/globalEvents";

export default {
  name: "PermissionDeniedAlert",
  methods: {
    alert() {
      this.$snotify.error(this.$t("permissionError"));
    },
  },
  created() {
    EventBus.$on(GLOBAL_EVENT_PERMISSION_DENIED, this.alert);
  },
  beforeDestroy() {
    EventBus.$off(GLOBAL_EVENT_PERMISSION_DENIED, this.alert);
  },
};
</script>

<style scoped></style>
